import { createAuth0 } from "@auth0/auth0-vue";
import { handleEnvVars } from "@/config/apiClient.config.ts";
const {
  auth0Domain,
  auth0Audience,
  auth0ClientId,
  auth0CallbackUrl,
  auth0Scopes,
} = handleEnvVars(import.meta.env);

export const auth0Instance = createAuth0(
  {
    domain: auth0Domain,
    clientId: auth0ClientId,

    cacheLocation: "memory",
    useRefreshTokens: true,
    useRefreshTokensFallback: true,

    authorizationParams: {
      redirect_uri: `${window.location.origin}${auth0CallbackUrl}`,
      audience: auth0Audience,
      oauthTokenScope: "openid profile email",
      scope: `${auth0Scopes} offline_access`,
    },
  },
  {
    errorPath: "/auth-error",
  },
);

export interface GetAccessTokenOptions {
  cacheMode?: "on" | "off" | "cache-only";
  audience?: string;
}

export const getAccessToken = async (
  options?: GetAccessTokenOptions,
): Promise<string> => {
  const { cacheMode, audience } = options ?? {};
  return await auth0Instance.getAccessTokenSilently({
    ...(cacheMode && { cacheMode }),
    ...(audience && { authorizationParams: { audience } }),
  });
};

export const handleAuthFailure = async (): Promise<void> => {
  await auth0Instance.loginWithRedirect({
    appState: { target: window.location.pathname },
  });
};

export const reauthenticate = async (options?: {
  audience?: string;
}): Promise<void> => {
  await auth0Instance.loginWithPopup({
    authorizationParams: {
      acr_values:
        "http://schemas.openid.net/pape/policies/2007/06/multi-factor",
      ...(options?.audience && { audience: options.audience }),
    },
  });
};
